import { Fragment } from "react";

export function FormButton({name,type = 'submit' , style , onClick , isLoading = false , isPrimary =false, disabled = false , classes =''}) {

    return (
        <button disabled = {isLoading} style={style} type={type} className={`btn text-24 ${isPrimary ?  'btn-primary' : '' } form-button ` + classes} onClick={()=>{
            if(onClick)
             onClick();
        }
        }>
        <Fragment>
            {
                name
            }
            {
                isLoading && <span className='mx-2 loading-btn'>
                    <img src='/assets/icons/loading.svg' width='24' height = '24'/>
                </span>
            }
        </Fragment>
        </button>
    );
}
